import "@arco-design/web-react/es/Drawer/style";
import _Drawer from "@arco-design/web-react/es/Drawer";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/VerificationCode/style";
import _VerificationCode from "@arco-design/web-react/es/VerificationCode";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import "@arco-design/web-react/es/Typography/style";
import _Typography from "@arco-design/web-react/es/Typography";
import _IconSafe from "@arco-design/web-react/icon/react-icon/IconSafe";
import "@arco-design/web-react/es/Divider/style";
import _Divider from "@arco-design/web-react/es/Divider";
import "@arco-design/web-react/es/Descriptions/style";
import _Descriptions from "@arco-design/web-react/es/Descriptions";
import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import "@arco-design/web-react/es/List/style";
import _List from "@arco-design/web-react/es/List";
import _IconPlus from "@arco-design/web-react/icon/react-icon/IconPlus";
import "@arco-design/web-react/es/Popconfirm/style";
import _Popconfirm from "@arco-design/web-react/es/Popconfirm";
import _IconDelete from "@arco-design/web-react/icon/react-icon/IconDelete";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import IconButton from '../NavBar/IconButton';
import request from '@/utils/request';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
function Setting() {
  const [visible, setVisible] = useState(false);
  const t = useLocale(locale);
  const userInfo = useSelector(state => state.userInfo);
  const [userProfile, setUserProfile] = useState({
    corp_name: '',
    dept_name: '',
    role_name: '',
    name: '',
    email: '',
    phone: ''
  });
  const [security, setSecurity] = useState({
    email: '',
    phone: ''
  });
  const [loading, setLoading] = useState(true);
  const [bindForm] = _Form.useForm();
  const [bindType, setBindType] = useState('');
  const [validated, setValidated] = useState(false);
  const [countDown, setCountDown] = useState(0);
  function handleUnbind(type) {
    const url = type === 'phone' ? '/v1/user/unbind_phone' : '/v1/user/unbind_email';
    request.post(url).then(res => {
      const {
        code,
        message
      } = res.data;
      if (code === 200) {
        _Message.success(message);
        fetchSecurity();
      } else {
        _Message.error(message);
      }
    });
  }
  const handleSendCode = async () => {
    if (countDown > 0 || loading) return;
    try {
      setLoading(true);
      bindForm.validate([bindType]).then(values => {
        request.post('/v1/user/verify_code', {
          type: 'bind',
          identifier: values[bindType]
        }).then(res => {
          const {
            code,
            message
          } = res.data;
          if (code === 200) {
            _Message.success(message);
            setCountDown(60);
            const timer = setInterval(() => {
              setCountDown(prev => {
                if (prev <= 1) {
                  clearInterval(timer);
                  return 0;
                }
                return prev - 1;
              });
            }, 1000);
          } else {
            _Message.error(message);
          }
        });
      });
    } catch (err) {
      _Message.error(t['security.setting.send_code.error']);
    } finally {
      setLoading(false);
    }
  };
  function handleBind(type) {
    const url = type === 'phone' ? '/v1/user/bind_phone' : '/v1/user/bind_email';
    const params = {};
    if (type === 'phone') {
      params.phone = bindForm.getFieldValue('phone');
    } else {
      params.email = bindForm.getFieldValue('email');
    }
    params.verify_code = bindForm.getFieldValue('verify_code');
    request.post(url, params).then(res => {
      const {
        code,
        message
      } = res.data;
      if (code === 200) {
        _Message.success(message);
        setBindType('');
        fetchSecurity();
      } else {
        _Message.error(message);
      }
    });
  }
  useEffect(() => {
    fetchProfile();
  }, [userInfo]);
  useEffect(() => {
    fetchSecurity();
  }, []);
  function fetchProfile() {
    setLoading(true);
    if (userInfo) {
      setUserProfile({
        corp_name: userInfo.corp_name || '',
        dept_name: userInfo.dept_name || '',
        role_name: userInfo.role_name || '',
        name: userInfo.name || '',
        email: userInfo.email || '',
        phone: userInfo.phone || ''
      });
    }
    setLoading(false);
  }
  function fetchSecurity() {
    setLoading(true);
    request.get('/v1/user/profile').then(res => {
      const {
        code,
        message,
        data
      } = res.data;
      if (code === 200) {
        setSecurity(data);
      } else {
        _Message.error(message);
      }
    }).finally(() => setLoading(false));
  }
  const validateEmailOrPhone = (v, cb) => {
    setCountDown(0);
    if (!v) {
      setValidated(false);
      return cb(t['security.setting.enter'] + t['security.setting.phone_or_email']);
    }
    if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(v) && !/^1[3456789]\d{9}$/.test(v)) {
      setValidated(false);
      return cb(t['security.setting.invalid_phone_or_email']);
    }
    setValidated(true);
    return cb();
  };
  const onFinishInputVerifyCode = () => {
    handleBind(bindType);
  };
  const renderProfile = () => {
    const profile = [{
      label: t['profile.infocorp_name'],
      value: userProfile.corp_name
    }, {
      label: t['profile.infodept_name'],
      value: userProfile.dept_name
    }, {
      label: t['profile.inforole_name'],
      value: userProfile.role_name
    }, {
      label: t['profile.infoname'],
      value: userProfile.name
    }, {
      label: t['profile.infoemail'],
      value: userProfile.email
    }, {
      label: t['profile.infophone'],
      value: userProfile.phone
    }];
    return profile;
  };
  const render = (item, index) => {
    const actionButton = item.value ? /*#__PURE__*/React.createElement(_Popconfirm, {
      title: t['security.setting.unbind'],
      content: t['security.setting.unbind.description'],
      okText: t['security.setting.ok'],
      cancelText: t['security.setting.cancel'],
      onOk: () => {
        handleUnbind(item.key);
      }
    }, /*#__PURE__*/React.createElement(IconButton, {
      icon: /*#__PURE__*/React.createElement(_IconDelete, null),
      status: "danger"
    })) : /*#__PURE__*/React.createElement(IconButton, {
      icon: /*#__PURE__*/React.createElement(_IconPlus, null),
      status: "success",
      onClick: () => {
        setBindType(item.key);
      }
    });
    return /*#__PURE__*/React.createElement(_List.Item, {
      key: item.key,
      actions: [actionButton]
    }, /*#__PURE__*/React.createElement(_List.Item.Meta, {
      title: item.title,
      description: item.value || t[`security.setting.none.${item.key}`]
    }));
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(_IconUser, null),
    onClick: () => setVisible(true)
  }), /*#__PURE__*/React.createElement(_Drawer, {
    width: 480,
    title: /*#__PURE__*/React.createElement(_Space, null, /*#__PURE__*/React.createElement(_IconUser, null), t['menu.profile.title']),
    unmountOnExit: true,
    visible: visible,
    onCancel: () => {
      setVisible(false);
    },
    footer: null
  }, /*#__PURE__*/React.createElement(_Descriptions, {
    column: 1,
    labelStyle: {
      width: 120
    },
    data: renderProfile()
  }), /*#__PURE__*/React.createElement(_Divider, null), /*#__PURE__*/React.createElement(_Typography.Title, {
    heading: 6
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_IconSafe, null), " ", t['security.setting.title'])), /*#__PURE__*/React.createElement(_List, {
    style: {
      width: '100%'
    },
    dataSource: [{
      key: 'email',
      title: t['security.setting.email'],
      value: security.email
    }, {
      key: 'phone',
      title: t['security.setting.phone'],
      value: security.phone
    }],
    render: render
    // footer={password}
  }), /*#__PURE__*/React.createElement(_Divider, null), bindType !== '' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Typography.Title, {
    heading: 6
  }, t['security.setting.bind']), /*#__PURE__*/React.createElement(_Form, {
    form: bindForm,
    wrapperCol: {
      span: 18
    },
    layout: "vertical"
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    label: bindType === 'phone' ? t['security.setting.phone'] : t['security.setting.email'],
    field: bindType,
    rules: [{
      validator: validateEmailOrPhone
    }, {
      required: true,
      message: t['public.validate.required']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    allowClear: true,
    placeholder: t['security.setting.enter'] + (bindType === 'phone' ? t['security.setting.phone'] : t['security.setting.email'])
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    label: t['security.setting.verify_code'],
    field: "verify_code",
    rules: [{
      required: true,
      message: t['public.validate.required']
    }],
    validateTrigger: ['onFinish']
  }, /*#__PURE__*/React.createElement(_VerificationCode, {
    size: "large",
    validate: ({
      inputValue
    }) => /[0-9]/.test(inputValue),
    onFinish: onFinishInputVerifyCode
  })), /*#__PURE__*/React.createElement("span", {
    className: styles['bind_button']
  }, /*#__PURE__*/React.createElement(_Button, {
    size: "large",
    onClick: () => {
      setBindType('');
    }
  }, t['security.setting.cancel']), /*#__PURE__*/React.createElement(_Button, {
    disabled: countDown > 0 || loading || !validated,
    type: "primary",
    size: "large",
    onClick: handleSendCode
  }, countDown > 0 ? `${t['security.setting.resend']} (${countDown}s)` : t['security.setting.send_code']))))));
}
export default Setting;